import { Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { matchPath, useLocation, useNavigate, useParams } from "react-router";
import { Links, Paths, UserTab } from "../../../../constants";

interface IParams {
  userId: string;
}

const UserNavBar = () => {
  const { userId } = useParams<keyof IParams>() as IParams;
  const navigate = useNavigate();
  const location = useLocation();
  const [currentTab, setCurrentTab] = useState<UserTab>(getTabForPath(location.pathname));

  function getTabForPath(path: string) {
    if (matchPath(Paths.UserImplementation, path)) {
      return UserTab.Implementation;
    }

    if (matchPath(Paths.UserStrategy, path)) {
      return UserTab.Strategy;
    }

    if (matchPath(Paths.UserMeetings, path)) {
      return UserTab.Meetings;
    }

    if (matchPath(Paths.UserFeedback, path)) {
      return UserTab.Feedback;
    }

    if (matchPath(Paths.UserMetrics, path)) {
      return UserTab.Metrics;
    }

    return UserTab.Overview;
  }

  useEffect(() => {
    setCurrentTab(getTabForPath(location.pathname));
  }, [location.pathname]);

  function handleTabChanged(_: React.SyntheticEvent, value: UserTab) {
    setCurrentTab(value);

    switch (value) {
      case UserTab.Overview:
        navigate(Links.User(userId));
        break;
      case UserTab.Strategy:
        navigate(Links.UserStrategy(userId));
        break;
      case UserTab.Implementation:
        navigate(Links.UserImplementation(userId));
        break;
      case UserTab.Meetings:
        navigate(Links.UserMeetings(userId));
        break;
      case UserTab.Feedback:
        navigate(Links.UserFeedback(userId));
        break;
      case UserTab.Metrics:
        navigate(Links.UserMetrics(userId));
        break;
    }
  }

  return (
    <Tabs value={currentTab} variant="scrollable" onChange={handleTabChanged}>
      <Tab label="Profile" value={UserTab.Overview} disableRipple />
      <Tab label="Strategy" value={UserTab.Strategy} disableRipple />
      <Tab label="Implementation" value={UserTab.Implementation} disableRipple />
      <Tab label="Meetings" value={UserTab.Meetings} disableRipple />
      <Tab label="Feedback" value={UserTab.Feedback} disableRipple />
      <Tab label="Metrics" value={UserTab.Metrics} disableRipple />
    </Tabs>
  );
};

export { UserNavBar };
